module.exports = __webpack_public_path__ + "img/icon_filter.0947f9fb.svg";